export const ReferralMedium = {
  REF_LINK: 'ref_link',
  WIDGET: 'widget',
  REFERRAL_LINK: 'referral_link',
};
